// client/src/dnd/emitter_tool/hooks/useModeHotkeys.js
import { useEffect } from "react";
import { setOriginDirection, setOriginTarget } from "../utils/modeSwitch";

/**
 * O → Origin-Direction (default / infinite)
 * P → Origin-Target (rule + point preset)
 */
export default function useModeHotkeys({ enable = true, pointRangeM = 9, timedSeconds } = {}) {
  useEffect(() => {
    if (!enable) return;
    const onKey = (e) => {
      if (e.repeat) return;
      if (e.key.toLowerCase() === "o") {
        setOriginDirection();
      } else if (e.key.toLowerCase() === "p") {
        setOriginTarget({ pointRangeM, timedSeconds });
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [enable, pointRangeM, timedSeconds]);
}
